import { render, staticRenderFns } from "./OthersReturn.vue?vue&type=template&id=3b3c26d9&scoped=true"
import script from "./OthersReturn.vue?vue&type=script&lang=js"
export * from "./OthersReturn.vue?vue&type=script&lang=js"
import style0 from "./OthersReturn.vue?vue&type=style&index=0&id=3b3c26d9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3c26d9",
  null
  
)

export default component.exports